module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lQGW0"))).then(() => parcelRequire('f4eak'));